import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonPageBreadcrumbsComponent } from './components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { CustomErrorComponent } from './components/custom-error/custom-error.component';
import { I18nModule, UrlModule } from '@spartacus/core';
import { AppPipesModule } from './pipes/app-pipes';
import { RouterModule } from '@angular/router';
import { IconModule } from '@spartacus/storefront';
import { PasswordStrengthMeterComponent } from './password-strength-meter/password-strength-meter.component';
import { CouterOfferModalComponent } from './components/counter-offer-modal/counter-offer-modal'

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AcceptBidModalComponent } from './components/accept-bid-modal/accept-bid-modal.component';
import { CancelBidModalComponent } from './components/cancel-bid-modal/cancel-bid-modal.component';
import { ConfirmBidModalComponent } from './components/confirm-bid-modal/confirm-bid-modal.component';
import { RejectBidModalComponent } from './components/reject-bid-modal/reject-bid-modal.component';
import {TwoDigitDecimaNumberDirective,AllowNegativeDecimalNumber,CommonDigitsDirective,allowPositiveAndNegativeNumbersDirective} from './components/two-digit-decima-number.directive';
import {restrictDecimaNumberDirective,PositiveNegativeDecimalNumberDirective} from './components/two-digit-decima-number.directive';
import {CopyDirective} from './components/two-digit-decima-number.directive';
import { PublishBatchModalComponent } from './components/publish-batch-modal/publish-batch-modal.component';
import { RecordPickupModalComponent } from './components/record-pickup-modal/record-pickup-modal.component';
import {UpdatePriceModalComponent}  from './components/update-price-modal/update-price-modal.component'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InventoryBreadcrumbComponent } from './components/inventory-breadcrumb/inventory-breadcrumb.component';
import { TenderDetailsModalComponent } from './components/tender-details-modal/tender-details-modal.component';
import { ShipmentStatusDirective } from './components/shipment-status.directive';
import { RemoveLeadingZerosPipe,NoDecimalPipe,ThreeDecimalPipe } from './components/remove-leading-zeros.pipe';
import { TenderConfirmBidModalComponent } from './components/tender-confirm-bid-modal/tender-confirm-bid-modal.component';
import { TenderPlaceBidComponent } from './components/tender-place-bid/tender-place-bid.component';
import { EditBidModalComponent } from './components/edit-bid-modal/edit-bid-modal.component';
import { TenderCancelBidComponent } from './components/tender-cancel-bid/tender-cancel-bid.component';
import { EditConfirmBidComponent } from './components/edit-confirm-bid/edit-confirm-bid.component';
import { TenderSelectProductsComponent } from './components/tender-select-products/tender-select-products.component';
import { TenderSelectProductsPlaceBidComponent } from './components/tender-select-products-place-bid/tender-select-products-place-bid.component';
import { TenderSelectProductsConfirmBidComponent } from './components/tender-select-products-confirm-bid/tender-select-products-confirm-bid.component';
import { QuoteSelectProductsComponent } from './components/quote-select-products/quote-select-products.component';
import { QuoteSelectProductsEditBidComponent } from './components/quote-select-products-edit-bid/quote-select-products-edit-bid.component';
import { QuoteSelectProductsEditConfirmBidComponent } from './components/quote-select-products-edit-confirm-bid/quote-select-products-edit-confirm-bid.component';
import { ITBEditBidComponent } from './components/itb-edit-bid/itb-edit-bid.component';
import { ITBEditConfirmBidComponent } from './components/itb-edit-confirm-bid/itb-edit-confirm-bid.component';
import { ITBQuoteSelectProductsComponent } from './components/itb-quote-select-products/itb-quote-select-products.component';
import { ITBQuoteEditBidComponent } from './components/itb-quote-edit-bid/itb-quote-edit-bid.component';
import { ITBQuoteEditConfirmBidComponent } from './components/itb-quote-edit-confirm-bid/itb-quote-edit-confirm-bid.component';
import { TenderPricingOptionComponent } from './components/tender-pricing-option/tender-pricing-option.component';
import { TenderPricingOptionConfirmBidComponent } from './components/tender-pricing-option-confirm-bid/tender-pricing-option-confirm-bid.component';
import { TenderAcceptBidComponent } from './components/tender-accept-bid/tender-accept-bid.component';
import { VesselNominationModalComponent } from './components/vessel-nomination-modal/vessel-nomination-modal.component';
import { FileUploadModule } from 'ng2-file-upload';
import { AttatchmentModalComponent } from './components/attatchment-modal/attatchment-modal.component';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        AppPipesModule,
        UrlModule,
        RouterModule,
        IconModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        FileUploadModule,
        CommonPageBreadcrumbsComponent, CustomErrorComponent,
        PasswordStrengthMeterComponent, CouterOfferModalComponent, AcceptBidModalComponent,
        CancelBidModalComponent, ConfirmBidModalComponent, RejectBidModalComponent,
        TwoDigitDecimaNumberDirective, AllowNegativeDecimalNumber, restrictDecimaNumberDirective, CopyDirective, allowPositiveAndNegativeNumbersDirective,
        PublishBatchModalComponent, RecordPickupModalComponent, UpdatePriceModalComponent, CommonDigitsDirective,
        InventoryBreadcrumbComponent,
        TenderDetailsModalComponent,
        ShipmentStatusDirective,
        RemoveLeadingZerosPipe, NoDecimalPipe, ThreeDecimalPipe,
        TenderConfirmBidModalComponent,
        TenderPlaceBidComponent,
        EditBidModalComponent,
        TenderCancelBidComponent,
        EditConfirmBidComponent,
        TenderSelectProductsComponent,
        TenderSelectProductsPlaceBidComponent,
        TenderSelectProductsConfirmBidComponent,
        QuoteSelectProductsComponent,
        QuoteSelectProductsEditBidComponent,
        QuoteSelectProductsEditConfirmBidComponent,
        ITBEditBidComponent,
        ITBEditConfirmBidComponent,
        ITBQuoteSelectProductsComponent,
        ITBQuoteEditBidComponent,
        ITBQuoteEditConfirmBidComponent,
        TenderPricingOptionComponent,
        TenderPricingOptionConfirmBidComponent,
        TenderAcceptBidComponent,
        VesselNominationModalComponent,
        AttatchmentModalComponent, PositiveNegativeDecimalNumberDirective
    ],
    exports: [CommonPageBreadcrumbsComponent, PasswordStrengthMeterComponent, CouterOfferModalComponent,
        AcceptBidModalComponent, CancelBidModalComponent, ConfirmBidModalComponent, RejectBidModalComponent,
        TwoDigitDecimaNumberDirective, AllowNegativeDecimalNumber, restrictDecimaNumberDirective, CopyDirective,
        InventoryBreadcrumbComponent, ShipmentStatusDirective, NoDecimalPipe, RemoveLeadingZerosPipe, CommonDigitsDirective,
        allowPositiveAndNegativeNumbersDirective, ThreeDecimalPipe, PositiveNegativeDecimalNumberDirective],
    schemas: [NO_ERRORS_SCHEMA]
})
export class SharedModule { }
